import React from 'react';
import { Filter, FunctionField } from 'react-admin';

import makeStyles from '@material-ui/core/styles/makeStyles';

import { Actions, Datagrid, List } from 'components/list';
import { ActionField } from 'components/fields';
import SearchInput from 'components/list/SearchInput';

import NameField from '../NameField';
import { RewardBadgeDto } from '../../types';
import AddBadgeButton from './AddBadgeButton';
import DeleteBadgeActionField from './DeleteBadgeActionField';
import EditBadgeActionField from './EditBadgeActionField';

const useStyles = makeStyles((theme) => ({
  form: {
    justifyContent: 'flex-end',
    width: '100%',
    '& .filter-field': {
      width: '50%',
    },
  },
}));

const BadgesFilter = (props) => {
  const classes = useStyles();

  return (
    <Filter classes={classes} {...props}>
      <SearchInput label="Search" source="search" alwaysOn onlySearch loading={props.loading} />
    </Filter>
  );
};

const BadgeActions = (props) => (
  <Actions {...props}>
    <AddBadgeButton />
  </Actions>
);

const Badges = (props) => {
  return (
    <List
      {...props}
      resource="rewardsBadge"
      basePath="/rewardsSettings"
      actions={<BadgeActions />}
      filters={<BadgesFilter />}>
      <Datagrid>
        <NameField source="title" imageSource="iconUrl" label="Badge" />
        <FunctionField
          label="Actions"
          sortable={false}
          render={(record: RewardBadgeDto) => {
            const actions = Array.isArray(record?.actions) ? record.actions : [];
            if (!actions.length) {
              return '-';
            }

            return (
              // API responses may use action.name or action.title for display text.
              actions
                .map((action) => action?.name ?? action?.title)
                .filter(Boolean)
                .join(', ')
            );
          }}
        />
        <FunctionField
          label="Notification"
          sortable={false}
          render={(record: RewardBadgeDto) => {
            const notificationTitle = record?.notificationTitle;
            const notificationBody = record?.notificationBody;

            if (!notificationTitle && !notificationBody) {
              return '-';
            }

            return (
              <>
                {notificationTitle}
                {notificationTitle && notificationBody ? <br /> : null}
                {notificationBody}
              </>
            );
          }}
        />
        <FunctionField
          label="Points"
          sortable={false}
          render={(record: RewardBadgeDto) =>
            typeof record?.points === 'number' ? record.points : 0
          }
        />
        <FunctionField
          label="Min required"
          sortable={false}
          render={(record: RewardBadgeDto) => {
            const actionsLength = Array.isArray(record?.actions) ? record.actions.length : 0;
            const minActionCount =
              typeof record?.minActionCount === 'number' ? record.minActionCount : 0;
            // Assumption: shipmentBased flag is present on badge records.
            const isShipmentBased = Boolean(record?.shipmentBased);
            // Default to 0/0 when values are missing to avoid NaN in the UI.
            return isShipmentBased
              ? `${minActionCount} shipments`
              : `${minActionCount}/${actionsLength} actions`;
          }}
        />

        <ActionField label="Manage">
          <EditBadgeActionField />
          <DeleteBadgeActionField />
        </ActionField>
      </Datagrid>
    </List>
  );
};

export default Badges;
